import { createSelector } from 'reselect';
const getUsage = state => state.documents.usage;
const getCount = createSelector(getUsage, usage => usage && usage.count);
export const getLimit = createSelector(getUsage, usage => usage && usage.limit);
export const getPortalIsAtLimit = createSelector([getLimit, getCount], (limit, count) => {
  if (!count) {
    return false;
  }
  return count >= limit;
});